import isNumber from "lodash/isNumber";

export const getPercentageClass = (uptime?: number, sla?: number): string => {
  if (!isNumber(uptime) || !isNumber(sla)) {
    return "";
  }

  if (uptime >= (1.0 + sla) / 2.0) {
    return "text-success";
  } else if (uptime > sla) {
    return "text-warning";
  } else {
    return "text-danger";
  }
};

export const getResponseTimeClass = (value?: number, sla?: number): string => {
  if (!isNumber(value) || !isNumber(sla)) {
    return "";
  }

  if (value <= sla * 0.7) {
    return "text-success";
  } else if (value <= sla) {
    return "text-warning";
  }

  return "text-danger";
};
